import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 0C5.384 0 0 5.384 0 12s5.384 12 12 12 12-5.382 12-12S18.616 0 12 0m1.502 7.5h2.4v2.367h-2.4zM8.1 7.5h2.4v2.367H8.1zM12 18c-3.309 0-6-2.691-6-6h2.4c0 1.985 1.615 3.6 3.6 3.6s3.6-1.615 3.6-3.6H18c0 3.309-2.691 6-6 6"
    }, null, -1)
  ])))
}
export default { render: render }